// ▼スクロール量がFVを超えたらクラスを付け替える処理
window.addEventListener("DOMContentLoaded", function () {
  const introElement = document.getElementById("js-courses");
  const headerElement = document.getElementById("js-arrow-btn");
  if (!introElement) {
    return false;
  }
  window.addEventListener("scroll", function () {
    const introDistance = introElement.getBoundingClientRect().top;
    if (introDistance < 0) {
      headerElement.classList.add("is-over");
    } else {
      headerElement.classList.remove("is-over");
    }
  });
});
